import React from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

const SortableWrapperHOC = ({
  onDragEnd,
  id,
}) => {
  const SortableWrapper = ({
    children,
  }) => (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={id}>
        {provided => (
          <>
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {children}
            </div>
            {provided.placeholder}
          </>
        )}
      </Droppable>
    </DragDropContext>
  );

  return SortableWrapper;
};

export { SortableWrapperHOC as SortableWrapper };
